import { forwardRef } from 'react';
import { cn } from '@/utils/cn';

const variants = {
  primary: 'bg-brand-ink text-brand-foreground hover:bg-chrome-border active:opacity-90',
  secondary: 'border border-border text-foreground bg-surface hover:border-brand',
  warning: 'bg-warning text-warning-foreground hover:opacity-90 active:opacity-80',
  ghost: 'text-foreground-muted hover:bg-surface-muted hover:text-foreground',
  link: 'text-brand-deep hover:text-brand hover:underline p-0 h-auto font-semibold',
} as const;

const sizes = {
  sm: 'h-8 px-3 text-body-sm',
  md: 'h-9 px-3.5 text-body-md',
} as const;

export type ButtonVariant = keyof typeof variants;
export type ButtonSize = keyof typeof sizes;

export const Button = forwardRef<
  HTMLButtonElement,
  React.ButtonHTMLAttributes<HTMLButtonElement> & {
    variant?: ButtonVariant;
    size?: ButtonSize;
  }
>(function Button({ className, variant = 'primary', size = 'md', type = 'button', ...props }, ref) {
  return (
    <button
      ref={ref}
      type={type}
      className={cn(
        'inline-flex items-center justify-center gap-1.5 rounded-lg font-medium transition-colors disabled:cursor-not-allowed disabled:opacity-50',
        variant !== 'link' && sizes[size],
        variants[variant],
        className
      )}
      {...props}
    />
  );
});
